// Ο πίνακας τροφοδοτεί το πλαϊνό μενού και τον τίτλο της γραμμής πλοήγησης.
// Οι ίδιες οι διαδρομές δηλώνονται στο views/Dashboard.jsx.
//
// Τα εικονίδια ήταν της γραμματοσειράς Nucleo, που οριζόταν με `@font-face` **μέσα
// στο `style.css`** του θέματος του 2019. Η διαγραφή του φύλλου στυλ θα άφηνε τα
// εικονίδια του μενού **κενά, χωρίς κανένα σφάλμα στην κονσόλα**: τα γλυφικά ήταν
// χαρακτήρες ιδιωτικής χρήσης, οπότε ο περιηγητής θα εμφάνιζε αντικαταστάτες.
// Αντιστοιχίστηκαν σε Font Awesome 6.
//
// Το πεδίο `component` του παλαιού πίνακα αφαιρέθηκε: με το react-router 6 οι
// διαδρομές δηλώνονται με `element` στο Dashboard, και ο πίνακας κρατούσε δεύτερη,
// ανενεργή αναφορά στα ίδια συστατικά.
//
// **Το προφίλ και η αποσύνδεση δεν είναι εδώ.** Μετακινήθηκαν στο μενού λογαριασμού
// της κεφαλίδας: είναι λογαριασμός και όχι πλοήγηση περιεχομένου, και στην κεφαλίδα
// είναι προσβάσιμα με ένα πάτημα και σε κινητό, όπου το πλαϊνό μενού είναι κρυμμένο.
// Οι διαδρομές τους παραμένουν αμετάβλητες, `/profile` και `/login`.
const routes = [
    {
        path: "/",
        name: "Συλλογές",
        icon: "fa-solid fa-layer-group"
    },
    {
        path: "/todos",
        name: "Καθήκοντα",
        // ΚΣΤ: το πλήθος **ενεργών** καθηκόντων μου. Ο ορισμός —μη
        // ολοκληρωμένα, σε ορατές συλλογές, **με ανάδοχο εμένα**— ζει στον
        // εξυπηρετητή· εδώ μένει μόνο το κλειδί και η εκφώνησή του.
        badge: "activeTasks",
        badgeLabel: "ενεργά καθήκοντα",
        icon: "fa-solid fa-list-check"
    },
    // Δεν εμφανίζεται στο πλαϊνό μενού. Παραμένει στον πίνακα, γιατί από αυτόν
    // προκύπτει ο τίτλος της γραμμής πλοήγησης σε κάθε διαδρομή.
    {
        path: "/profile",
        name: "Προφίλ",
        icon: "fa-solid fa-user",
        hidden: true
    },
    // ── P1-5 ────────────────────────────────────────────────────────────────
    // Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης: τρεις
    // κλάδοι που επεξεργάζονται τον ίδιο πίνακα συγκρούονται σε κάθε merge,
    // ενώ τρεις προσθήκες στο τέλος συγχωνεύονται καθαρά.
    //
    // ΛΑ-14: η αναζήτηση χρειάζεται **δική της θέση στην πλοήγηση**. Λειτουργία
    // που υπάρχει στο API και δεν έχει σημείο εισόδου στη διεπαφή δεν καλύπτει
    // απαίτηση — είναι η κατηγορία Α του Κεφαλαίου 6.
    {
        path: "/search",
        name: "Αναζήτηση",
        icon: "fa-solid fa-magnifying-glass"
    },
    // ── P1-8 ────────────────────────────────────────────────────────────────
    // Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
    //
    // Το `adminOnly` δεν το γνωρίζει το `MainMenu`: το φιλτράρισμα γίνεται στο
    // `Dashboard`, που είναι το μόνο σημείο που ξέρει ποιος είναι συνδεδεμένος.
    // Είναι **ευχρηστία και όχι ασφάλεια** — ο φράχτης είναι το
    // `integration:manage` του Πίνακα 1, στον εξυπηρετητή.
    //
    // **«Κλειδιά πρόσβασης» και όχι «Κλειδιά API» (20/08).** Το μενού έλεγε το ένα
    // και η οθόνη το άλλο, για το ίδιο πράγμα — ΜΛΑ-02. Επιλέχθηκε ο ελληνικός
    // όρος, που είναι ήδη ο όρος της οθόνης και της τεκμηρίωσης: σε διεπαφή που
    // είναι ολόκληρη στα ελληνικά, το «API» είναι αμετάφραστο ακρωνύμιο. Η ταύτιση
    // των δύο σημείων **ελέγχεται** πλέον από δοκιμή αντί να συντηρείται με μνήμη.
    {
        path: "/api-keys",
        name: "Κλειδιά πρόσβασης",
        icon: "fa-solid fa-key",
        adminOnly: true
    },
    // ── P1-7 ────────────────────────────────────────────────────────────────
    // Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
    //
    // ΛΑ-22: οι ειδοποιήσεις χρειάζονται **δική τους θέση στην πλοήγηση**, γιατί
    // το εύρος τους είναι ο **χρήστης** και όχι μια συλλογή — δεν υπάρχει σελίδα
    // μέσα στην οποία θα ζούσαν φυσικά. Η ροή κάθε συλλογής, αντίθετα, ζει μέσα
    // στη σελίδα της.
    //
    // Το `badge` το γεμίζει το `Dashboard`, που είναι το μόνο σημείο που ξέρει
    // ποιος είναι συνδεδεμένος. Ο πίνακας δηλώνει μόνο ότι η εγγραφή **δέχεται**
    // σήμανση.
    {
        path: "/notifications",
        name: "Ειδοποιήσεις",
        icon: "fa-solid fa-bell",
        badge: "unreadNotifications"
    },
    // ── P3-11 ───────────────────────────────────────────────────────────────
    // Η βιβλιοθήκη συστατικών **έλειπε από τον πίνακα**, οπότε η μπάρα της έγραφε
    // «Η σελίδα δεν βρέθηκε» πάνω από σελίδα που δουλεύει — και ο τίτλος της
    // καρτέλας θα έλεγε το ίδιο. Κρυφή από το μενού, όπως το προφίλ: ο πίνακας
    // είναι **και** η πηγή του τίτλου, όχι μόνο του μενού.
    // ── feat/topics ─────────────────────────────────────────────────────────
    // Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
    //
    // **Ορατό σε όλους**, χωρίς `adminOnly`: η ΛΑ-06 ζητά προβολή των συλλογών
    // «ανά θεματικό αντικείμενο», που είναι ανάγνωση για κάθε χρήστη. Τα κουμπιά
    // διαχείρισης κρύβονται **μέσα** στη σελίδα — και ο φράχτης είναι το
    // `topic:manage` του Πίνακα 1, στον εξυπηρετητή.
    {
        path: "/topics",
        name: "Θεματικά αντικείμενα",
        icon: "fa-solid fa-sitemap"
    },
    {
        path: "/design-check",
        name: "Βιβλιοθήκη συστατικών",
        icon: "fa-solid fa-swatchbook",
        hidden: true
    },
    // ── Σετ Γ ───────────────────────────────────────────────────────────────
    // Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
    //
    // Πίνακας 1, `user:manage`. Το `adminOnly` το φιλτράρει το `Dashboard`, που
    // είναι το μόνο σημείο που ξέρει ποιος είναι συνδεδεμένος — **ευχρηστία και
    // όχι ασφάλεια**: ο φράχτης είναι ολόκληρος ο δρομολογητής χρηστών του API.
    //
    // Η εγγραφή είναι **απαραίτητη και όχι διακοσμητική**: χωρίς αυτήν η σελίδα
    // φτάνει μόνο με πληκτρολόγηση διεύθυνσης, δηλαδή δεν καλύπτει απαίτηση κατά
    // τον κανόνα 2 του πίνακα κάλυψης — και είναι η κατηγορία Α, λειτουργία που
    // υπάρχει στο API και δεν φτάνει στον χρήστη.
    {
        path: "/users",
        name: "Μέλη της ομάδας",
        icon: "fa-solid fa-users",
        adminOnly: true
    },

    // ── ΛΑ-27: συνδρομές γεγονότων ──────────────────────────────────────────
    // Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
    //
    // Πίνακας 1, `integration:manage`. Ισχύει ό,τι και για τα κλειδιά: το
    // `adminOnly` είναι **ευχρηστία και όχι ασφάλεια** — ο φράχτης είναι ολόκληρος
    // ο δρομολογητής webhook του API, που απαιτεί καθολικό ρόλο **διαβασμένο από
    // τη βάση** (D39).
    //
    // Ο μηχανισμός του P2-1 δούλευε πλήρως και ήταν **απρόσιτος**: ο διαχειριστής
    // όριζε συνδρομές μόνο με απευθείας κλήσεις. Λειτουργία που δεν φτάνει στον
    // χρήστη δεν καλύπτει απαίτηση.
    {
        path: "/webhooks",
        name: "Συνδρομές γεγονότων",
        icon: "fa-solid fa-tower-broadcast",
        adminOnly: true
    }
];

export default routes;
